import { useEffect, useRef } from 'react'

export function getAvatarText(name) {
  if (!name) {
    return ''
  }
  var shortNameArray = name.split(' ')
  var shortName = name.substring(0, 2)
  if (shortNameArray.length > 1) {
    shortName = shortNameArray[0][0] + '' + shortNameArray[1][0]
  }
  return shortName.toUpperCase()
}

export function useHorizontalScroll() {
  const elRef = useRef()
  useEffect(() => {
    const el: any = elRef.current
    if (el) {
      const onWheel = (e) => {
        if (e.deltaY == 0) return
        e.preventDefault()
        el.scrollTo({
          left: el.scrollLeft + e.deltaY * 2,
          behavior: 'smooth',
        })
      }
      el.addEventListener('wheel', onWheel)
      return () => el.removeEventListener('wheel', onWheel)
    }
  }, [])
  return elRef
}
